module.exports = __webpack_public_path__ + "img/icon_familly_white.4183674c.svg";